let accessToken;
export const setAccessToken = token => {
    accessToken = token
}

export const getAccessToken = () => {
    return accessToken
}

export const deleteAccessToken = () => {
    accessToken = null
}